import { dateWasReached } from '@src/common';

export function canResendCode(lockedUntil: string | null | undefined): boolean {
  if (!lockedUntil) return true;
  return dateWasReached(lockedUntil);
}
